import { AxiosService } from './axios.service'

const baseURL = 'venda-de-passagem'

/**
 * Defines the API methods for ticket sale
 */
export class TicketSaleService {
	/**
	 * Get the origins
	 * @return {Promise<any>} The list of origins
	 */
	static getOrigins({ isMuvibus, isPublicBody, userId }) {
		return AxiosService.get(
			`${baseURL}/localidades-de-origem?isMuvibus=${isMuvibus}&isPublicBody=${isPublicBody}&userID=${userId}`
		).then(({ data }) => data)
	}

	/**
	 * Get the destinations
	 * @return {Promise<any>} The list of destinations
	 */
	static getDestinations({
		id,
		isMuvibus,
		isPublicBody,
		userId,
		hasChildren,
	}) {
		return AxiosService.get(
			`${baseURL}/localidades-de-destino?isMuvibus=${isMuvibus}&isPublicBody=${isPublicBody}&userID=${userId}&hasChildren=${hasChildren}`,
			{
				params: {
					OriginId: id,
				},
			}
		).then(
			({ data }) => (
				data.data.sort((a, b) =>
					(a.city + a.state).localeCompare(b.city + b.state)
				),
				data
			)
		)
	}

	/**
	 * Search the trips
	 * @return {Promise<any>} The list of trips
	 */
	static async searchTrips({
		originId,
		destinationId,
		tripDateGoing,
		tripDateReturn,
		destinationCity,
	}) {
		const { data } = await AxiosService.get(`${baseURL}/rotas`, {
			params: {
				originId,
				destinationId,
				tripdate: tripDateGoing,
				tripDateReturn,
				destinationCity,
			},
		})

		return data.data
	}

	/**
	 * Get the bus seats
	 * @return {Promise<any>} The bus seats information
	 */
	static getBusData(params, requestId) {
		return AxiosService.getKeepFirst(
			requestId,
			`${baseURL}/onibus`,
			{ params }
		).then(({ data }) => data)
	}

	/**
	 * Finalize the purchase
	 * @return {Promise<any} the purchase result
	 */
	static finalizePurchase(params) {
		return AxiosService.post(`${baseURL}/confirmar-venda`, params).then(
			({ data }) => data
		)
	}

	/**
	 * Book a bus seat
	 * @return {Promise<any} the booking result
	 */
	static bookBusSeat(params) {
		return AxiosService.post(`${baseURL}/reservar`, params).then(
			({ data }) => data
		)
	}

	/**
	 * Cancel a bus seat booking
	 * @return {Promise<any} the cancelation result
	 */
	static cancelBusSeatBooking(params) {
		return AxiosService.post(`${baseURL}/cancelar-reserva`, params).then(
			({ data }) => data
		)
	}

	/**
	 * Request for the authenticator form
	 * @return {Promise<any} the purchase result
	 */
	static sendGetNetDebitCard(params) {
		return AxiosService.post(
			`${baseURL}/formulario-autenticador`,
			params
		).then(({ data }) => data)
	}

	/**
	 * Submit the PaRes
	 * @return {Promise<any} the purchase result
	 */
	static confirmPaResDebitCard(params) {
		return AxiosService.post(
			`gateway-getnet/confirmar-pagamento-debito`,
			params
		).then(({ data }) => data)
	}

	/**
	 * Get parameters to family discount
	 * @return {Promise<any} the family discount parameters return
	 */
	static getDiscountParameters() {
		return AxiosService.get(`${baseURL}/parametros`).then(({ data }) => data)
	}

	/**
	 * Get bankslip parameters
	 * @return {Promise<any} bankslip parameters
	 */
	static getBankSlipParameters() {
		return AxiosService.get(`${baseURL}/boleto-parametros`).then(
			({ data }) => data
		)
	}

	/**
	 * Get muvicard discount
	 * @return {Promise<any} the family discount parameters return
	 */
	static getMuvicardDiscountParameters(params) {
		return AxiosService.post(`${baseURL}/muvicard-parametros`, params).then(
			({ data }) => data
		)
	}

	/**
	 * Get automatic discount coupon from logged user
	 * @return {Promise<any}
	 */
	static getAutomaticDiscountCoupon(params) {
		return AxiosService.get(`${baseURL}/buscar-cupom-automatico`, {
			params,
		}).then(({ data }) => data)
	}
}

export default TicketSaleService
